<template>
    <div>
        <!-- <topSearch></topSearch> -->
        <!-- <breadcrumb></breadcrumb> -->

        <div class="top-title-content">
            <span class="title">센터관리</span>
            <span class="txt">센터 기본정보를 등록하고, 관리한다.</span>
        </div>

        <div class="com-tab">
            <button class="on">기본정보</button>
            <button @click="onClickRouter('/madmin/business/center/contract_list')">전자계약서 발송 내역</button>
        </div>
        <div class="com-table-top">
            <span v-if="initCreate" class="title">센터등록</span>
            <span v-else class="title">센터수정</span>
            <div v-if="!initCreate" class="logo-area">
                <div class="logo-box">
                    <span class="logo">
                        <img :src="logoUrl" alt="" />
                    </span>
                </div>
                <div class="info-box">
                    <span class="location">{{ centerName }}</span>
                    <span v-if="address" class="address">{{ `${address} ${addressDetail}` }}</span>
                    <span class="address">{{ `${telNoFirst}-${telNoSecond}-${telNoThird}` }}</span>
                    <span class="type">{{ centerType == 'M' ? '본점' : '지점' }}</span>
                </div>
            </div>
        </div>
        <div class="com-table-wrap">
            <span class="top-title"><span class="title">센터 기본정보</span></span>
            <loading-spinner v-if="isLoading"></loading-spinner>
            <div v-else class="info-edit-table">
                <div class="table-wrapper" style="width: 1020px">
                    <table>
                        <colgroup>
                            <col style="width: 160px" />
                            <col style="width: auto" />
                            <col style="width: 160px" />
                            <col style="width: auto" />
                        </colgroup>
                        <tbody>
                            <tr>
                                <th>로고</th>
                                <td colspan="3">
                                    <div class="file-logo">
                                        <span class="logo"><img :src="imageUrl" alt="" /></span>
                                    </div>
                                    <div class="com-file-single">
                                        <b-form-file
                                            id="file1"
                                            accept=".jpg, .png, .gif"
                                            plain
                                            @change="handleImage"
                                        ></b-form-file>
                                        <label for="file1">파일첨부</label>
                                        <span class="info-txt">
                                            <span class="imp">*</span>
                                            흰 배경에 180px × 70px 사이즈 로고를 권장합니다.
                                        </span>
                                    </div>
                                </td>
                            </tr>
                            <!--                            <tr>-->
                            <!--                                <th>센터구분</th>-->
                            <!--                                <td>-->
                            <!--                                    <div class="com-radio">-->
                            <!--                                        <input type="radio" name="radio-1" id="radio-1-1" value="M" v-model="centerType">-->
                            <!--                                        <label for="radio-1-1">본점</label>-->
                            <!--                                    </div>-->
                            <!--                                    <div class="com-radio">-->
                            <!--                                        <input type="radio" name="radio-1" id="radio-1-2" value="C" v-model="centerType">-->
                            <!--                                        <label for="radio-1-2">지점</label>-->
                            <!--                                    </div>-->
                            <!--                                </td>-->
                            <!--                            </tr>-->
                            <tr>
                                <th>
                                    업종
                                    <span class="imp">*</span>
                                </th>
                                <td colspan="3">
                                    <select-form
                                        :select-data="['선택', ...bizTypeList]"
                                        :select-value="['', ...bizTypeValueList]"
                                        :selected-value="bizType"
                                        class="w240"
                                        @update:set="(val) => (bizType = val)"
                                    ></select-form>
                                </td>
                            </tr>
                            <tr>
                                <th>
                                    센터명
                                    <span class="imp">*</span>
                                </th>
                                <td colspan="3">
                                    <input
                                        v-model.trim="centerName"
                                        class="w400"
                                        maxlength="20"
                                        minlength="2"
                                        type="text"
                                    />
                                </td>
                            </tr>
                            <tr>
                                <th>
                                    관리자(담당자)
                                    <br />
                                    아이디
                                    <span class="imp">*</span>
                                </th>
                                <template v-if="initCreate">
                                    <td colspan="3">
                                        <div class="com-email">
                                            <input
                                                v-model.trim="centerAdminId[0]"
                                                :disabled="!initCreate"
                                                class="first"
                                                type="text"
                                            />
                                            <span class="txt">@</span>
                                            <input
                                                v-model.trim="centerAdminId[1]"
                                                :disabled="!initCreate"
                                                class="last"
                                                type="text"
                                            />
                                            <select-form
                                                v-if="initCreate"
                                                :select-data="['직접 입력', ...emailTypeList]"
                                                :select-value="['', ...emailTypeValueList]"
                                                :selected-value.sync="centerAdminId[1]"
                                                @update:set="$forceUpdate()"
                                            ></select-form>
                                        </div>
                                    </td>
                                </template>
                                <template v-else>
                                    <td colspan="3">
                                        <div class="com-email">
                                            <input v-model.trim="contactUserEmail[0]" class="first" type="text" />
                                            <span class="txt">@</span>
                                            <input v-model.trim="contactUserEmail[1]" class="last" type="text" />
                                            <select-form
                                                :select-data="['직접 입력', ...emailTypeList]"
                                                :select-value="['', ...emailTypeValueList]"
                                                :selected-value.sync="contactUserEmail[1]"
                                                @update:set="$forceUpdate()"
                                            ></select-form>
                                        </div>
                                    </td>
                                </template>
                            </tr>
                            <template v-if="initCreate">
                                <tr>
                                    <th>
                                        관리자
                                        <br />
                                        비밀번호
                                        <span class="imp">*</span>
                                    </th>
                                    <td colspan="3">
                                        <input v-model="centerAdminPassword" class="w400" type="password" />
                                    </td>
                                </tr>
                                <tr>
                                    <th>
                                        관리자
                                        <br />
                                        비밀번호 확인
                                        <span class="imp">*</span>
                                    </th>
                                    <td colspan="3">
                                        <input v-model="centerAdminRePassword" class="w400" type="password" />
                                    </td>
                                </tr>
                            </template>
                            <tr>
                                <th>
                                    관리자(담당자)명
                                    <span class="imp">*</span>
                                </th>
                                <td colspan="3">
                                    <input
                                        v-model.trim="contactUserName"
                                        class="w400"
                                        maxlength="20"
                                        minlength="2"
                                        type="text"
                                    />
                                </td>
                            </tr>
                            <tr>
                                <th>
                                    관리자(담당자) 연락처
                                    <span class="imp">*</span>
                                </th>
                                <td colspan="3">
                                    <div class="com-tel">
                                        <input
                                            v-model.trim="contactUserTelFirst"
                                            :disabled="!initCreate"
                                            maxlength="3"
                                            type="text"
                                        />
                                        <span class="bar">-</span>
                                        <input
                                            v-model.trim="contactUserTelSecond"
                                            :disabled="!initCreate"
                                            maxlength="4"
                                            type="text"
                                        />
                                        <span class="bar">-</span>
                                        <input
                                            v-model.trim="contactUserTelThird"
                                            :disabled="!initCreate"
                                            maxlength="4"
                                            type="text"
                                        />
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <th>
                                    사업자 번호
                                    <span class="imp">*</span>
                                </th>
                                <td colspan="3">
                                    <div class="com-tel">
                                        <input v-model.trim="bizNoFirst" maxlength="3" type="text" />
                                        <span class="bar">-</span>
                                        <input v-model.trim="bizNoSecond" maxlength="2" type="text" />
                                        <span class="bar">-</span>
                                        <input v-model.trim="bizNoThird" maxlength="5" type="text" />
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <th>
                                    전화번호
                                    <span class="imp">*</span>
                                </th>
                                <td colspan="3">
                                    <div class="com-tel">
                                        <input v-model.trim="telNoFirst" maxlength="3" type="text" />
                                        <span class="bar">-</span>
                                        <input v-model.trim="telNoSecond" maxlength="4" type="text" />
                                        <span class="bar">-</span>
                                        <input v-model.trim="telNoThird" maxlength="4" type="text" />
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <th>팩스번호</th>
                                <td colspan="3">
                                    <div class="com-tel">
                                        <input v-model.trim="faxNoFirst" maxlength="3" type="text" />
                                        <span class="bar">-</span>
                                        <input v-model.trim="faxNoSecond" maxlength="4" type="text" />
                                        <span class="bar">-</span>
                                        <input v-model.trim="faxNoThird" maxlength="4" type="text" />
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <th>이메일</th>
                                <td colspan="3">
                                    <div class="com-email">
                                        <input v-model.trim="emailFirst" class="first" type="text" />
                                        <span class="txt">@</span>
                                        <input v-model.trim="emailSecond" class="last" type="text" />
                                        <select-form
                                            :select-data="['직접 입력', ...emailTypeList]"
                                            :select-value="['', ...emailTypeValueList]"
                                            @update:set="(val) => (emailSecond = val)"
                                        ></select-form>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <th>주소</th>
                                <td colspan="3">
                                    <div class="com-address" style="width: 500px !important">
                                        <input
                                            v-model="address"
                                            class="address"
                                            readonly
                                            style="width: 400px !important"
                                            type="text"
                                        />
                                        <button class="com-btn" @click="postPop = true">주소검색</button>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <th>상세주소</th>
                                <td colspan="3">
                                    <input v-model="addressDetail" class="w400" maxlength="30" type="text" />
                                </td>
                            </tr>
                            <tr>
                                <th>사용여부</th>
                                <td>
                                    <div class="flex">
                                        <div class="com-radio">
                                            <input
                                                id="radio-2-1"
                                                v-model="accessYn"
                                                :value="true"
                                                name="radio-2"
                                                type="radio"
                                            />
                                            <label for="radio-2-1">사용가능</label>
                                        </div>
                                        <div class="com-radio">
                                            <input
                                                id="radio-2-2"
                                                v-model="accessYn"
                                                :value="false"
                                                name="radio-2"
                                                type="radio"
                                            />
                                            <label for="radio-2-2">사용불가 (핏투데이케어 접속 불가)</label>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <th>SMS 충전 금액</th>
                                <td colspan="3">
                                    <span class="sms-charge-data">{{ pointData }}원</span>
                                    <button class="com-btn" @click="editSmsChargePop = true">금액 추가</button>
                                </td>
                            </tr>
                            <!-- <tr class="span-row">
                <th rowspan="2">SMS 발신번호</th>
                <td>
                  <span class="sms-num-data">010-0000-0000</span>
                  <button class="com-btn btn-rep ml-8">대표</button>
                </td>
              </tr>
              <tr class="span-row">
                <td>
                  <span class="sms-num2-data">010-0000-1234</span>
                </td>
              </tr> -->
                            <tr class="span-row" v-if="phoneNumbers.length === 0">
                                <th rowspan="1">SMS 발신번호</th>
                                <td colspan="3">등록된 전화번호가 없습니다</td>
                            </tr>
                            <tr v-else class="span-row">
                                <th :rowspan="subNumbers ? subNumbers.lenth + 1 : 1">SMS 발신번호</th>
                                <td colspan="3">
                                    <span class="sms-num-data">{{ mainNumber }}</span>
                                    <button class="com-btn btn-rep ml-8">대표</button>
                                </td>
                            </tr>
                            <tr v-for="(number, index) in subNumbers" :key="index" class="span-row">
                                <td colspan="3">
                                    <span class="sms-num2-data">{{ number.send_no }}</span>
                                </td>
                            </tr>
                            <tr>
                                <th>핏페이 가입여부</th>
                                <td colspan="3">
                                    <div class="flex">
                                        <div class="com-radio">
                                            <input
                                                id="radio-f-1"
                                                v-model="fpMode"
                                                value="N"
                                                name="radio-f"
                                                type="radio"
                                            />
                                            <label for="radio-f-1">미가입</label>
                                        </div>
                                        <div class="com-radio">
                                            <input
                                                id="radio-f-2"
                                                v-model="fpMode"
                                                value="T"
                                                name="radio-f"
                                                type="radio"
                                            />
                                            <label for="radio-f-2">핏페이+단말기</label>
                                        </div>
                                        <div class="com-radio">
                                            <input
                                                id="radio-f-3"
                                                v-model="fpMode"
                                                value="U"
                                                name="radio-f"
                                                type="radio"
                                            />
                                            <label for="radio-f-3">핏페이(URL결제)</label>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <th>프로그램 사용여부</th>
                                <td colspan="3">
                                    <div class="flex">
                                        <div class="com-radio">
                                            <input
                                                id="radio-2-1"
                                                v-model="accessYn"
                                                :value="true"
                                                name="radio-2"
                                                type="radio"
                                            />
                                            <label for="radio-2-1">사용가능</label>
                                        </div>
                                        <div class="com-radio">
                                            <input
                                                id="radio-2-2"
                                                v-model="accessYn"
                                                :value="false"
                                                name="radio-2"
                                                type="radio"
                                            />
                                            <label for="radio-2-2">사용불가 (핏투데이케어 접속 불가)</label>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <th>키오스크 사용여부</th>
                                <td colspan="3">
                                    <div class="flex">
                                        <div class="com-radio">
                                            <input
                                                id="radio-kiosk-1"
                                                v-model="kioskYn"
                                                :value="true"
                                                name="radio-kiosk"
                                                type="radio"
                                            />
                                            <label for="radio-kiosk-1">사용가능</label>
                                        </div>
                                        <div class="com-radio">
                                            <input
                                                id="radio-kiosk-2"
                                                v-model="kioskYn"
                                                :value="false"
                                                name="radio-kiosk"
                                                type="radio"
                                            />
                                            <label for="radio-kiosk-2">사용불가</label>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <th>출입문 사용여부</th>
                                <td>
                                    <div class="flex">
                                        <div class="com-radio">
                                            <input
                                                id="radio-entry-1"
                                                v-model="entryYn"
                                                :value="true"
                                                name="radio-entry"
                                                type="radio"
                                            />
                                            <label for="radio-entry-1">사용가능</label>
                                        </div>
                                        <div class="com-radio">
                                            <input
                                                id="radio-entry-2"
                                                v-model="entryYn"
                                                :value="false"
                                                name="radio-entry"
                                                type="radio"
                                            />
                                            <label for="radio-entry-2">사용불가</label>
                                        </div>
                                    </div>
                                </td>
                                <th>출입문 SN</th>
                                <td>
                                    <input type="text" placeholder="출입문 SN" class="w-100" v-model="doorSN" />
                                </td>
                            </tr>
                            <tr>
                                <th>슈프리마 기기 사용</th>
                                <td>
                                    <div class="flex">
                                        <div class="com-radio">
                                            <input id="radio-clue-1" v-model="useClue" :value="true" name="radio-clue" type="radio" />
                                            <label for="radio-clue-1">사용가능</label>
                                        </div>
                                        <div class="com-radio">
                                            <input id="radio-clue-2" v-model="useClue" :value="false" name="radio-clue" type="radio" />
                                            <label for="radio-clue-2">사용불가</label>
                                        </div>
                                    </div>
                                </td>
                                <th>CLUe placeId</th>
                                <td>
                                    <input
                                        type="number"
                                        placeholder="CLUe placeId"
                                        class="w-100"
                                        v-model.number="cluePlaceId"
                                        :disabled="!useClue"
                                    />
                                </td>
                            </tr>
                            <tr>
                                <th>CLUe 출입문</th>
                                <td colspan="3">
                                    <div class="flex">
                                        <button
                                            class="com-btn gray"
                                            style="flex-shrink:0;white-space:nowrap;"
                                            :disabled="!useClue || !cluePlaceId || loadingDoors || clueDoorLocked"
                                            @click="loadClueDoors"
                                        >
                                            {{ loadingDoors ? '불러오는 중…' : '불러오기' }}
                                        </button>
                                        <select
                                            v-model.number="clueDoorId"
                                            :disabled="!clueDoorOptions.length || clueDoorLocked"
                                            class="w-100"
                                            style="margin-left:8px;"
                                        >
                                            <option :value="null">선택 안 함</option>
                                            <option v-for="d in clueDoorOptions" :key="d.doorId" :value="d.doorId">
                                                {{ d.doorName }} ({{ d.doorId }}){{ d.connected ? '' : ' — 연결 끊김' }}
                                            </option>
                                        </select>
                                    </div>
                                    <div v-if="clueDoorId && clueDoorName" style="color:#888;font-size:12px;">
                                        현재 설정: {{ clueDoorName }} ({{ clueDoorId }})
                                    </div>
                                    <div v-if="clueDoorLocked" style="color:#c0392b;font-size:12px;">
                                        공간 ID가 변경되었습니다. 이대로 저장하면 기존 출입문 연결이 해제됩니다.
                                        출입문은 공간 ID를 저장한 뒤 다시 선택하세요.
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td colspan="4" style="color:#888;font-size:12px;">
                                    ※ 슈프리마 사용/placeId 변경은 <b>변경 이후 신규 등록부터</b> 적용됩니다. 기존 등록 회원·단말은 자동 이관되지 않습니다.
                                </td>
                            </tr>
                            <tr>
                                <th>NICEPAY ID</th>
                                <td>
                                    <input type="text" placeholder="ID" v-model="npLoginId" />
                                </td>
                                <th>MID</th>
                                <td>
                                    <input type="text" placeholder="MID" class="w-100" v-model="npMid" />
                                </td>
                            </tr>
                            <tr>
                                <th>KEY</th>
                                <td colspan="3">
                                    <input type="text" placeholder="KEY" class="w-100" v-model="npMkey" />
                                </td>
                            </tr>
                            <tr>
                                <th>메모</th>
                                <td colspan="3">
                                    <textarea v-model="memo" class="com-textarea w680" maxlength="300"></textarea>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <div v-if="!initCreate" style="display: flex; justify-content: end; margin-top: 8px">
                        <input id="upload" style="display: none" type="file" accept=".xlsx" @change="handleUpload" />
                        <label class="com-btn" for="upload">스튜디오 메이트 엑셀 업로드</label>
                    </div>
                </div>
                <div class="bottom-btn">
                    <button class="com-btn" @click="prevPage">취소</button>
                    <button v-if="initCreate" class="com-btn blue" @click="centerCreate">등록</button>
                    <button v-else class="com-btn blue" @click="centerUpdate">수정</button>
                </div>
            </div>
        </div>

        <!-- 주소 검색 레이어 팝업 -->
        <div v-if="postPop === true" class="layer-pop square">
            <div class="view-content w600">
                <button class="close" @click="postPop = false"><span class="blind">팝업 닫기</span></button>
                <div class="scroll-area com-scroll-y">
                    <span class="title">주소 검색</span>
                    <daum-post-code :on-complete="handleAddress"></daum-post-code>
                </div>
            </div>
        </div>

        <!-- SMS 금액 충전 레이어 팝업 -->
        <div v-show="editSmsChargePop" class="layer-pop square" :style="{ zIndex: 33 }">
            <div class="view-content w600">
                <button class="close" @click="editSmsChargePop = false">
                    <span class="blind">팝업 닫기</span>
                </button>
                <div class="scroll-area com-scroll-y">
                    <p class="pop-tit">SMS 금액 충전</p>
                    <div class="sms-charge-pop">
                        <table class="com-table">
                            <tbody>
                                <tr>
                                    <th>센터명</th>
                                    <td>
                                        <input v-model.trim="centerName" maxlength="30" type="text" readonly />
                                    </td>
                                </tr>
                                <tr>
                                    <th>보유 금액</th>
                                    <td class="won-text">
                                        <input v-model="pointData" maxlength="30" type="text" readonly />
                                    </td>
                                </tr>
                                <tr>
                                    <th>충전 금액</th>
                                    <td class="won-text">
                                        <div class="com-radio-wrap">
                                            <div class="com-radio">
                                                <input
                                                    id="amount-add"
                                                    name="chargeType"
                                                    type="radio"
                                                    v-model="chargeType"
                                                    value="add"
                                                />
                                                <label for="amount-add">금액 추가</label>
                                            </div>
                                            <div class="com-radio">
                                                <input
                                                    id="amount-subtract"
                                                    name="chargeType"
                                                    type="radio"
                                                    v-model="chargeType"
                                                    value="subtract"
                                                />
                                                <label for="amount-subtract">금액 차감(환불일 경우)</label>
                                            </div>
                                        </div>
                                        <input v-model="amount" maxlength="30" type="text" placeholder="금액 입력" />
                                    </td>
                                </tr>
                                <tr>
                                    <th>메모</th>
                                    <td>
                                        <input v-model="payMemo" type="text" />
                                    </td>
                                </tr>
                            </tbody>
                        </table>

                        <div class="bottom-btn">
                            <button class="com-btn" @click="editSmsChargePop = false">취소</button>
                            <button class="com-btn blue" @click="handlePointChange">저장</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import api from '@/assets/js/api';
import paymentApi from '@/assets/js/paymentApi';
import { Utils } from '@/assets/js/utils';
import { validateBizNo, validateEmail, validateTelNo } from '@/assets/js/validation.js';
import moment from 'moment';
import XLSX from 'xlsx';
import LoadingSpinner from '../../../../components/LoadingSpinner';

export default {
    name: 'businessCenterList',
    components: { LoadingSpinner },
    computed: {
        // 등록, 수정 페이지인지 구분 (true를 반환하면 등록, false를 반환하면 수정)
        initCreate() {
            let create = true;
            if (this.centerId != null) {
                create = false;
            }
            return create;
        },
        // 센터 최고관리자 이메일 (센터 생성 이전)
        centerAdminFullEmail() {
            return `${this.centerAdminId[0]}@${this.centerAdminId[1]}`;
        },
        // 센터 담당자 이메일 (센터 생성 이후)
        fullContactUserEmail() {
            return `${this.contactUserEmail[0]}@${this.contactUserEmail[1]}`;
        },
        // CLUe placeId를 마지막으로 불러온 값과 다르게 바꾼 상태인지 여부
        // (서버가 저장 시 placeId 변경을 감지하면 clueDoorId를 무조건 비우므로, 저장 전까지는 출입문 선택을 잠근다)
        clueDoorLocked() {
            return this.cluePlaceId !== this.clueSavedPlaceId;
        },
    },
    data() {
        return {
            isLoading: false,
            postPop: false,
            editSmsChargePop: false,
            centerId: this.$route.params.id,
            centerType: 'M',
            bizType: '',
            centerName: '',
            bizNo: '',
            bizNoFirst: '',
            bizNoSecond: '',
            bizNoThird: '',
            logoImageFile: {
                filename: '',
                mimetype: '',
                base64data: '',
            },
            contactUserName: '',
            contactUserTelFirst: '',
            contactUserTelSecond: '',
            contactUserTelThird: '',
            contactUserTel: '',
            telNoFirst: '',
            telNoSecond: '',
            telNoThird: '',
            telNo: '',
            faxNoFirst: '',
            faxNoSecond: '',
            faxNoThird: '',
            faxNo: '',
            emailFirst: '',
            emailSecond: '',
            email: '',
            address: '',
            addressDetail: '',
            fullAddress: '',
            accessYn: true,
            kioskYn: false,
            entryYn: false,
            fpMode: 'N',
            doorSN: '',
            useClue: false,
            cluePlaceId: null,
            clueDoorId: null,
            clueDoorName: null,
            clueDoorOptions: [],
            loadingDoors: false,
            clueSavedPlaceId: null,
            npLoginId: '',
            npMid: '',
            npMkey: '',
            memo: '',
            bizTypeList: ['헬스장', '필라테스', '요가', 'PT샵', '스포츠시설', '뷰티', '기타'],
            bizTypeValueList: ['H', 'F', 'Y', 'P', 'S', 'B', 'E'],
            emailTypeList: [...this.$emailType],
            emailTypeValueList: [...this.$emailType],
            imageUrl: '',
            logoUrl: '',
            contactUserEmail: ['', ''],
            centerAdminId: ['', ''],
            centerAdminPassword: '',
            centerAdminRePassword: '',
            smsApiKey: '',
            smsUserId: '',
            customerParam: [],
            pointData: 0,
            payMemo: '',
            amount: '',
            chargeType: '',
            phoneNumbers: [],
            mainNumber: '',
            subNumbers: [],
            migExcelErrors: [],

        };
    },
    watch: {
        // placeId가 편집 중 바뀌면 이전 공간에서 불러온 목록은 무효이므로 비운다.
        // ⚠️ clueDoorId/clueDoorName은 절대 여기서 비우지 않는다. 비우면 placeId를 오타로 바꿨다가
        //    되돌려 저장할 때 payload가 clueDoorId:null이 되고, 서버는 최종 placeId가 그대로라
        //    mustClearDoor=false로 판단해 그 null을 저장한다 → 기존 문 연결이 조용히 삭제된다.
        //    placeId가 실제로 바뀐 채 저장되면 서버가 알아서 비우므로 화면에서 선반영할 필요가 없다.
        cluePlaceId(newValue) {
            if (newValue !== this.clueSavedPlaceId) {
                this.clueDoorOptions = [];
            }
        },
    },
    mounted() {
        if (this.centerId != null) {
            this.fetchCenterDetail();
            this.fetchCenterDoor();
            this.getPoints();
            this.getPhoneNumber();
        } else {
            // this.imageUrl = '/img/temp/brand_logo.png';
            // this.logoUrl = '/img/temp/brand_logo.png';
        }
    },
    methods: {
        async getPoints() {
            try {
                const response = await paymentApi.get(`/admin/api/payment/point/${this.centerId}`);
                this.pointData = response.data.point; // API 응답을 데이터 속성에 저장
                console.log('포인트 정보 ', response);
            } catch (error) {
                console.error('Error getting points', error);
            }
        },
        async handlePointChange() {
            try {
                const payload = {
                    centerId: parseInt(this.centerId, 10),
                    memo: this.payMemo,
                    // 금액 추가일 때는 양수로, 차감일 때는 음수로 처리
                    point:
                        this.chargeType === 'add'
                            ? Math.abs(parseInt(this.amount, 10))
                            : -Math.abs(parseInt(this.amount, 10)),
                };
                if (!payload.centerId || isNaN(payload.point)) {
                    alert('올바르지 않은 입력입니다.');
                    return;
                }
                const response = await paymentApi.put(
                    'admin/api/admin-management-center/handling-center-point',
                    payload
                );
                if (response && response.data) {
                    alert('처리되었습니다.');
                    this.getPoints();
                    this.editSmsChargePop = false;
                } else {
                    alert('처리 중 문제가 발생했습니다.');
                }
            } catch (error) {
                console.error('Point handling error:', error);
                alert('처리 중 오류가 발생했습니다.');
            }
        },
        async getPhoneNumber() {
            const response = await paymentApi.post(`/admin/api/center-phone/${this.centerId}/list`, {
                page: 1,
                skip: 10,
            });

            this.phoneNumbers = response.data.list;

            const presentNumber = this.phoneNumbers.find((number) => number.is_present);
            const subNumber = this.phoneNumbers.filter((number) => number.is_sub_number);

            if (presentNumber) {
                this.mainNumber = this.formatPhone(presentNumber.send_no);
            } else if (this.phoneNumbers.length > 0) {
                this.mainNumber = this.formatPhone(this.phoneNumbers[0].send_no);
            }

            if (subNumber.length > 0) {
                this.subNumbers = subNumber.map((number) => ({
                    ...number,
                    send_no: this.formatPhone(number.send_no),
                }));
            }
        },
        formatPhone(value) {
            let phone = value.replace(/[^0-9]/g, ''); // 숫자가 아닌 문자 제거
            if (phone.length === 11) {
                phone = phone.replace(/(\d{3})(\d{4})(\d{4})/, '$1-$2-$3'); // 하이픈 추가
            } else if (phone.length === 10) {
                phone = phone.replace(/(\d{3})(\d{3})(\d{4})/, '$1-$2-$3'); // 하이픈 추가
            } else if (phone.length === 9) {
                phone = phone.replace(/(\d{2})(\d{3})(\d{4})/, '$1-$2-$3'); // 하이픈 추가
            }
            return phone;
        },
        // 센터 정보 API
        getCenterDetail(centerId) {
            return api.get(`/admin/api/center/${centerId}`);
        },

        // 센터 정보 fetch
        async fetchCenterDetail() {
            try {
                this.isLoading = true;
                const { data } = await this.getCenterDetail(this.centerId);
                if (data.logoUrl) {
                    this.logoUrl = data.logoUrl;
                    this.imageUrl = data.logoUrl;
                } else {
                    // this.logoUrl = '/img/temp/brand_logo.png';
                    // this.imageUrl = '/img/temp/brand_logo.png';
                    this.logoUrl = '';
                    this.imageUrl = '';
                }

                this.centerType = data.centerType;
                this.bizType = data.bizType;
                this.centerName = data.centerName;
                this.bizNo = data.bizNo;
                this.contactUserName = data.contactUserName;
                this.fullAddress = `${data.address} ${data.addressDetail}`;
                this.address = data.address;
                this.addressDetail = data.addressDetail;
                this.memo = data.memo;
                this.accessYn = data.accessYn;
                this.kioskYn = data.kioskYn || false;
                this.entryYn = data.entryYn || false;
                this.useClue = data.useClue || false;
                this.cluePlaceId = data.cluePlaceId === null || data.cluePlaceId === undefined ? null : data.cluePlaceId;
                this.clueDoorId = data.clueDoorId === undefined ? null : data.clueDoorId;
                this.clueDoorName = data.clueDoorName === undefined ? null : data.clueDoorName;
                this.clueSavedPlaceId = this.cluePlaceId;
                this.formatPhoneNumber(data.contactUserTel, 'contact');
                this.formatPhoneNumber(data.telNo, 'tel');
                this.formatPhoneNumber(data.faxNo, 'fax');
                this.formatBizNo(data.bizNo);
                this.formatEmail(data.email);
                this.smsApiKey = data.smsApiKey;
                this.smsUserId = data.smsUserId;
                this.fpMode = data.fpMode || 'N';
                this.npLoginId = data.npLoginId;
                this.npMid = data.npMid;
                this.npMkey = data.npMkey;
                this.isLoading = false;

                if (!Utils.isEmpty(data.contactUserEmail)) {
                    this.contactUserEmail = data.contactUserEmail.split('@');
                }

                console.log('===> Loading center detail Successfully : ', data);
            } catch (error) {
                console.log(error);
                alert('오류가 발생했습니다.');
            }
        },

        async fetchCenterDoor() {
            try {
                const { data } = await api.get(`/admin/api/center/${this.centerId}/door`);

                this.doorSN = data.sn;
            } catch (e) {
            }
        },

        async loadClueDoors() {
            this.loadingDoors = true;
            try {
                const { data } = await api.get(`/admin/api/center/${this.centerId}/clue/doors`);
                this.clueDoorOptions = (data && data.doors) || [];
                if (!this.clueDoorOptions.length) {
                    alert('해당 공간에 등록된 출입문이 없습니다.');
                }
            } catch (e) {
                const msg = e && e.response && e.response.data && e.response.data.message;
                alert(msg || '출입문 목록을 불러오지 못했습니다.');
            } finally {
                this.loadingDoors = false;
            }
        },

        // 이메일 주소 Split
        formatEmail(email) {
            if (!email) return;
            if (email !== '') {
                this.emailFirst = email.split('@')[0];
                this.emailSecond = email.split('@')[1];
            }
        },

        // 연락처 Split
        formatPhoneNumber(no, type) {
            if (no === null) return;
            const length = no.length;
            if (type == 'contact') {
                if (length == 11 && no.substr(0, 2) != '02') {
                    // 010-1234-1234
                    this.contactUserTelFirst = no.substr(0, 3);
                    this.contactUserTelSecond = no.substr(3, 4);
                    this.contactUserTelThird = no.substr(7, 4);
                } else if (length == 10 && no.substr(0, 2) != '02') {
                    // 031-123-4567
                    this.contactUserTelFirst = no.substr(0, 3);
                    this.contactUserTelSecond = no.substr(3, 3);
                    this.contactUserTelThird = no.substr(6, 4);
                } else if (length == 10 && no.substr(0, 2) == '02') {
                    // 02-1234-4567
                    this.contactUserTelFirst = no.substr(0, 2);
                    this.contactUserTelSecond = no.substr(2, 4);
                    this.contactUserTelThird = no.substr(6, 4);
                } else if (length == 9 && no.substr(0, 2) == '02') {
                    // 02-123-4567
                    this.contactUserTelFirst = no.substr(0, 2);
                    this.contactUserTelSecond = no.substr(2, 3);
                    this.contactUserTelThird = no.substr(5, 4);
                }
            } else if (type == 'tel') {
                if (length == 11 && no.substr(0, 2) != '02') {
                    this.telNoFirst = no.substr(0, 3);
                    this.telNoSecond = no.substr(3, 4);
                    this.telNoThird = no.substr(7, 4);
                } else if (length == 10 && no.substr(0, 2) != '02') {
                    this.telNoFirst = no.substr(0, 3);
                    this.telNoSecond = no.substr(3, 3);
                    this.telNoThird = no.substr(6, 4);
                } else if (length == 10 && no.substr(0, 2) == '02') {
                    this.telNoFirst = no.substr(0, 2);
                    this.telNoSecond = no.substr(2, 4);
                    this.telNoThird = no.substr(6, 4);
                } else if (length == 9 && no.substr(0, 2) == '02') {
                    this.telNoFirst = no.substr(0, 2);
                    this.telNoSecond = no.substr(2, 3);
                    this.telNoThird = no.substr(5, 4);
                } else if (length == 8) {
                    // 국번이 없는경우
                    this.telNoFirst = '';
                    this.telNoSecond = no.substr(0, 4);
                    this.telNoThird = no.substr(4, 4);
                }
            } else if (type == 'fax') {
                if (length == 11 && no.substr(0, 2) != '02') {
                    this.faxNoFirst = no.substr(0, 3);
                    this.faxNoSecond = no.substr(3, 4);
                    this.faxNoThird = no.substr(7, 4);
                } else if (length == 10 && no.substr(0, 2) != '02') {
                    this.faxNoFirst = no.substr(0, 3);
                    this.faxNoSecond = no.substr(3, 3);
                    this.faxNoThird = no.substr(6, 4);
                } else if (length == 10 && no.substr(0, 2) == '02') {
                    this.faxNoFirst = no.substr(0, 2);
                    this.faxNoSecond = no.substr(2, 4);
                    this.faxNoThird = no.substr(6, 4);
                } else if (length == 9 && no.substr(0, 2) == '02') {
                    this.faxNoFirst = no.substr(0, 2);
                    this.faxNoSecond = no.substr(2, 3);
                    this.faxNoThird = no.substr(5, 4);
                }
            }
        },

        // 사업자 번호 Split
        formatBizNo(bizNo) {
            if (!bizNo) return;
            if (bizNo !== '') {
                this.bizNoFirst = bizNo.substr(0, 3);
                this.bizNoSecond = bizNo.substr(3, 2);
                this.bizNoThird = bizNo.substr(5, 5);
            }
        },

        // 하이픈(-) 으로 나눠진 숫자 합치기
        attachNumberValues() {
            this.bizNo = this.bizNoFirst + this.bizNoSecond + this.bizNoThird;
            this.contactUserTel = this.contactUserTelFirst + this.contactUserTelSecond + this.contactUserTelThird;
            this.telNo = this.telNoFirst + this.telNoSecond + this.telNoThird;
            this.faxNo = this.faxNoFirst + this.faxNoSecond + this.faxNoThird;
            this.email = `${this.emailFirst}@${this.emailSecond}`;
        },

        // 센터 등록 API
        postCenterCreate(centerData) {
            const account = this.getAccountParams();
            return api.post(`/admin/api/center/create/${account}`, {
                ...centerData,
            });
        },

        // 센터 최고관리자 아이디, 비밀번호 base64 형식으로 변환 ( 아이디^비밀번호 )
        getAccountParams() {
            return window.btoa(`${this.centerAdminFullEmail}^${this.centerAdminPassword}`);
        },

        // 센터 등록
        async centerCreate() {
            this.attachNumberValues();
            const validate = this.validateValue();
            if (validate) {
                alert(validate);
                return;
            }
            const centerData = {
                centerName: this.centerName,
                crossLessonYn: false,
                bizNo: this.bizNo,
                logoImageFile: {
                    filename: this.logoImageFile.filename,
                    mimetype: this.logoImageFile.mimetype,
                    base64data: this.logoImageFile.base64data,
                },
                centerType: this.centerType,
                bizType: this.bizType,
                contactUserName: this.contactUserName,
                contactUserTel: this.contactUserTel,
                telNo: this.telNo,
                faxNo: this.faxNo,
                email: this.email === '@' ? '' : this.email,
                address: this.address,
                addressDetail: this.addressDetail,
                billPosAttendAutoYn: false,
                billAppAttendAutoYn: false,
                billStaffOffAutoYn: false,
                hollidayOffAutoYn: false,
                accessYn: this.accessYn,
                kioskYn: this.kioskYn,
                entryYn: this.entryYn,
                memo: this.memo,
                fpMode: this.fpMode,
                npLoginId: this.npLoginId,
                npMid: this.npMid,
                npMkey: this.npMkey,
            };
            if (this.smsApiKey && this.smsUserId) {
                centerData.smsApiKey = this.smsApiKey;
                centerData.smsUserId = this.smsUserId;
            }
            if (centerData.logoImageFile.filename == '') {
                delete centerData.logoImageFile;
            }
            try {
                this.isLoading = true;
                const { data } = await this.postCenterCreate(centerData);
                console.log('===> Success Center create : ', data);
                alert('센터가 등록 되었습니다.');
                this.isLoading = false;
                this.$router.push({ name: 'businessCenterList' });
            } catch (error) {
                this.isLoading = false;
                // alert('센터 등록중 오류가 발생했습니다.');
                Utils.alertResponseErrorMessge(error);
                console.log('===> Failed Center create : ', error);
            }
        },

        // 센터 수정 API
        async putCenterUpdate(centerId, centerData) {
            let response;

            /*
      const chunkSize = 500;
      for (let i = 0; i < this.customerParam.length; i += chunkSize) {
        centerData.append = i !== 0;
        centerData.migration = this.customerParam.slice(i, i + chunkSize);
        response = await api.put(`/admin/api/center/${centerId}`, {
          ...centerData,
        }, {
          timeout: 300000
        });
      */
            if (this.customerParam.length) {
                const chunkSize = 500;
                for (let i = 0; i < this.customerParam.length; i += chunkSize) {
                    centerData.append = i !== 0;
                    centerData.migration = this.customerParam.slice(i, i + chunkSize);
                    response = await api.put(
                        `/admin/api/center/${centerId}`,
                        {
                            ...centerData,
                        },
                        {
                            timeout: 300000,
                        }
                    );
                }
            } else {
                response = await api.put(
                    `/admin/api/center/${centerId}`,
                    {
                        ...centerData,
                    },
                    {
                        timeout: 300000,
                    }
                );
            }

            return response.data;
        },

        // 센터 수정
        async centerUpdate() {
            if (!confirm('기존의 마이그레이션 데이터가 존재하면 삭제됩니다. 그래도 진행하시겠습니까?')) {
                return;
            }
            this.isLoading = true;
            this.attachNumberValues();
            const validate = this.validateValue();
            if (validate) {
                alert(validate);
                return;
            }

            if (this.useClue && !(Number.isInteger(this.cluePlaceId) && this.cluePlaceId >= 1 && this.cluePlaceId <= 2147483647)) {
                alert('CLUe placeId는 1~2147483647 범위의 정수여야 합니다.');
                this.isLoading = false;
                return;
            }

            const centerData = {
                centerName: this.centerName,
                bizNo: this.bizNo,
                logoImageFile: {
                    filename: this.logoImageFile.filename,
                    mimetype: this.logoImageFile.mimetype,
                    base64data: this.logoImageFile.base64data,
                },
                centerType: this.centerType,
                bizType: this.bizType,
                contactUserEmail: this.fullContactUserEmail,
                contactUserName: this.contactUserName,
                contactUserTel: this.contactUserTel,
                telNo: this.telNo,
                faxNo: this.faxNo,
                email: this.email === '@' ? '' : this.email,
                address: this.address,
                addressDetail: this.addressDetail,
                accessYn: this.accessYn,
                kioskYn: this.kioskYn,
                entryYn: this.entryYn,
                useClue: this.useClue,
                cluePlaceId: this.cluePlaceId === '' ? null : this.cluePlaceId,
                clueDoorId: this.clueDoorId === '' ? null : this.clueDoorId,
                memo: this.memo,
                fpMode: this.fpMode,
                npLoginId: this.npLoginId,
                npMid: this.npMid,
                npMkey: this.npMkey,
            };

            if (this.smsApiKey && this.smsUserId) {
                centerData.smsApiKey = this.smsApiKey;
                centerData.smsUserId = this.smsUserId;
            }

            if (centerData.logoImageFile.filename == '') {
                delete centerData.logoImageFile;
            }

            try {
                const { data } = await this.putCenterUpdate(this.centerId, centerData);

                await this.updateDoor();

                alert('센터정보가 수정 되었습니다.');

                await this.$router.push({name: 'businessCenterList'});
            } catch (error) {
                console.error(error);
                alert('오류가 발생했습니다.');
                console.log(centerData);
            }

            this.isLoading = false;
        },

        async updateDoor() {
            if (!this.doorSN) return;

            await api.put(`/admin/api/center/${this.centerId}/door/${this.doorSN}`);
        },

        // 필수값 체크
        validateValue() {
            if (this.bizType === '') {
                return '업종을 선택하세요.';
            } else if (this.centerName === '') {
                return '센터명을 입력하세요.';
            } else if (this.bizNo.length < 2) {
                return '사업자 번호를 입력하세요.';
            } else if (this.telNo.length < 8) {
                return '전화번호를 입력하세요.';
            }

            if (this.centerName !== '' && this.centerName.length < 2) {
                return '센터명을 다시 확인해주세요.';
            } else if (this.contactUserName !== '' && this.contactUserName.length < 2) {
                return '담당자명을 다시 확인해주세요.';
            }

            if (this.bizNo !== '' && !validateBizNo(this.bizNo)) {
                return '사업자번호를 다시 확인해주세요.';
            } else if (this.contactUserTel.trim() === '' || !validateTelNo(this.contactUserTel)) {
                return '담당자 연락처를 다시 확인해주세요.';
            } else if (this.telNo !== '' && !validateTelNo(this.telNo)) {
                return '전화번호를 다시 확인해주세요.';
            } else if (this.faxNo !== '' && !validateTelNo(this.faxNo)) {
                return '팩스번호를 다시 확인해주세요.';
            } else if (this.emailFirst + this.emailSecond !== '' && !validateEmail(this.email)) {
                return '이메일 주소를 다시 확인해주세요.';
            }

            if (this.initCreate) {
                // 등록일 때만 체크
                // 최고관리자 아이디
                if (this.centerAdminId[0].trim() === '' && this.centerAdminId[0].trim() === '') {
                    return '센터 관리자 아이디를 입력해주세요.';
                } else if (
                    !validateEmail(this.centerAdminFullEmail) ||
                    this.centerAdminId[0].length < 3 ||
                    this.centerAdminId[1].length < 6
                ) {
                    return '센터 관리자 아이디를 다시 확인해주세요.';
                }
                if (this.contactUserName.trim() === '') {
                    return '센터 관리자명을 입력해주세요.';
                }

                // 비밀번호
                if (this.centerAdminPassword.trim() === '') {
                    return '센터 관리자 비밀번호를 입력해주세요.';
                } else if (this.centerAdminRePassword.trim() === '') {
                    return '센터 관리자 비밀번호 확인을 입력해주세요.';
                } else if (this.centerAdminPassword.trim().length < 8) {
                    return '센터 관리자 비밀번호를 8자리 이상 입력하세요.';
                } else if (this.centerAdminRePassword.trim().length < 8) {
                    return '센터 관리자 비밀번호 확인을 8자리 이상 입력하세요.';
                }
                if (this.centerAdminPassword.trim() !== this.centerAdminRePassword.trim()) {
                    return '센터 관리자 비밀번호가 일치하지 않습니다. 다시 입력해주세요.';
                }
            }
        },

        // 취소 버튼
        prevPage() {
            this.$router.push({ name: 'businessCenterList' });
        },

        // Image 핸들러
        handleImage(e) {
            const selectedImage = e.target.files[0];
            this.logoImageFile.filename = selectedImage.name;
            this.logoImageFile.mimetype = selectedImage.type;
            this.createBase64Image(selectedImage);
        },

        // Base64 Image 생성
        createBase64Image(fileObj) {
            const reader = new FileReader();
            reader.onload = (e) => {
                this.imageUrl = e.target.result;
                this.logoImageFile.base64data = this.imageUrl.split(',')[1];
            };
            reader.readAsDataURL(fileObj);
        },

        // 다음 주소 API 콜백
        handleAddress(data) {
            let fullAddress = data.address;
            let extraAddress = '';
            if (data.addressType === 'R') {
                if (data.bname !== '') {
                    extraAddress += data.bname;
                }
                if (data.buildingName !== '') {
                    extraAddress += extraAddress !== '' ? `, ${data.buildingName}` : data.buildingName;
                }
                fullAddress += extraAddress !== '' ? ` (${extraAddress})` : '';
            }
            this.address = fullAddress; // e.g. '서울 성동구 왕십리로2길 20 (성수동1가)'
            this.postPop = false;
        },
        async sendGetDuplicateAttendNo(centerId, attendNo) {
            return Promise.all([api.get(`/admin/api/center/${centerId}/customer/attend-no/${attendNo}/duplicate`)]);
        },
        async checkDuplicateAttNumber(attendNo) {
            const { data } = await this.sendGetDuplicateAttendNo(this.centerId, attendNo);

            return !!data;
        },
        async  getFetchTeachers(name) {  // 강사 리스트 조회 api
            return  await  api.get(`/admin/api/center/${this.centerId}/staff/teachers/list?name=${name}`);
        },
        // 엑셀 등록
        async handleUpload(data) {
            const file = data.target.files[0];
            this.customerParam = [];
            this.migExcelErrors = [];

            const id = this.centerId;
            if (!file) {
                alert('파일을 등록해주세요.');
                return;
            }
            const reader = new FileReader();
            this.isLoading = true;
            // let rownum = 1;
            reader.onload = () => {
                const fileData = reader.result;
                const wb = XLSX.read(fileData, { type: 'binary' });
                wb.SheetNames.forEach((sheetName) => {
                    // rownum++;
                    const rowObj = XLSX.utils.sheet_to_json(wb.Sheets[sheetName], { 
                    raw: false,
                    });

                    const processedData = rowObj.map(row => {
                    const newRow = {...row};
                    // 각 필드 순회하면서 날짜 형식 체크 및 변환
                    Object.keys(newRow).forEach(key => {
                        if (this.isDateFormat(newRow[key])) {
                            newRow[key] = this.convertToYYYYMMDD(newRow[key]);
                        }
                    });
                    return newRow;
                    });


                    this.checkVaildMigExcelData(processedData);
                    rowObj.forEach((row) => this.makeCustomerListForParam(row));
                    this.checkDuplicateAttendNo();
                    this.isLoading = false; 
                });
            };
            await reader.readAsBinaryString(file);
        },

         isDateFormat(str) {
            if (!str || typeof str !== 'string') return false;
            // MM/DD/YY 형식 체크 (8/6/24 형식)
            const dateRegex = /^(0?[1-9]|1[0-2])\/(0?[1-9]|[12][0-9]|3[01])\/\d{2}$/;
            return dateRegex.test(str);
        },

        // 날짜 변환 함수
        convertToYYYYMMDD(dateStr) {
           const [month, day, year] = dateStr.split('/');
           return `20${year}-${month.padStart(2,'0')}-${day.padStart(2,'0')}`;
        },

        checkDuplicateAttendNo() {
            let dupAvoidNum = 0;
            this.customerParam.sort((a, b) => {
                if (a.attendNo === b.attendNo) {
                    b.attendNo += dupAvoidNum;
                    dupAvoidNum++;
                }
            });
        },
        RETURN_WEEKS_DIFF_NUM(rowDatum, rowDatum2) {
            return moment(rowDatum2).diff(moment(rowDatum), 'weeks');
        },
        makeCustomerListForParam(rowData) {
            const daysBeforeUnixEpoch = 70 * 365 + 19;
            const hour = 60 * 60 * 1000;
            let birthday = rowData['생년월일'];
            if (typeof birthday === 'string' && birthday) {
                birthday = birthday.trim();
                if (moment(birthday).isValid()) {
                    birthday = moment(birthday).format('YYYYMMDD');
                } else if (moment(birthday, 'YYYY년 M월 D일').isValid()) {
                    birthday = moment(birthday, 'YYYY년 M월 D일').format('YYYYMMDD');
                } else {
                    console.log(`Invalid date: ${birthday}`);
                    birthday = '';
                }
            } else if (typeof birthday === 'number') {
                birthday = moment(
                    new Date(Math.round((birthday - daysBeforeUnixEpoch) * 24 * hour) + 12 * hour)
                ).format('YYYYMMDD');
            } else {
                birthday = '';
            }
            if (rowData['이름'] && rowData['이름'].trim().length > 24) {
                console.log(`Name length exceed: ${rowData['이름']}`);
            }
            if (rowData['전화번호'] && rowData['전화번호'].length > 13) {
                console.log(`Invalid phone number: ${rowData['전화번호']}`);
            }
            if (!rowData['결제금액']) {
                rowData['결제금액'] = 0;
            }
            if (typeof rowData['수강권시작일'] === 'number') {
                // const excelDateNumber = 44444; // example Excel date number (represents January 1, 2023)
                // Convert the Excel date number to a JavaScript date object
                rowData['수강권시작일'] = moment(new Date((rowData['수강권시작일'] - 25569) * 86400 * 1000)).format(
                    'YYYY-MM-DD'
                );
            }
            if (typeof rowData['수강권종료일'] === 'number') {
                // const excelDateNumber = 44444; // example Excel date number (represents January 1, 2023)
                // Convert the Excel date number to a JavaScript date object
                rowData['수강권종료일'] = moment(new Date((rowData['수강권종료일'] - 25569) * 86400 * 1000)).format(
                    'YYYY-MM-DD'
                );
            }

            if (!rowData['수강권발급일'] || String(rowData['수강권발급일']).trim() === '') {
                rowData['수강권발급일'] = moment().format('YYYY-MM-DD');
            } else if (typeof rowData['수강권발급일'] === 'number') {
                rowData['수강권발급일'] = moment(new Date((rowData['수강권발급일'] - 25569) * 86400 * 1000)).format(
                    'YYYY-MM-DD'
                );
            }

            if (!rowData['결제일시'] || String(rowData['결제일시']).trim() === '') {
                rowData['결제일시'] = moment().format('YYYY-MM-DD');
            }

            const WEEKS_DIFF_NUM = this.RETURN_WEEKS_DIFF_NUM(rowData['수강권시작일'], rowData['수강권종료일']);
            const customerInfo = {
                info: {
                    createdAt: rowData['등록일'] || moment().format('YYYY-MM-DD'),
                    createdName: 'root@root.com',
                    updatedName: 'root@root.com',
                },
                name: rowData['이름'] ? rowData['이름'].trim() : '',
                nickName: rowData['이름'] ? rowData['이름'].trim() : '',
                attendNo: rowData['전화번호'] ? rowData['전화번호'].slice(-4) : '',
                parentTelNoYn: false,
                phone: rowData['전화번호'] ? rowData['전화번호'].trim().replace(/-/g, "") : '',
                email: '@',
                taxTelNo: '',
                password: '',
                birthday,
                sex: rowData['성별'] === '여성' || rowData['성별'] === '' ? 'W' : 'M',
                mileage: 0,
                address: rowData['주소'],
                addressDetail: rowData['상세주소'],
                mktAgreeEmail: true,
                mktAgreeSms: true,
                mktAgreePush: true,
                joinTermAgreeId: 0,
                memo: rowData['메모'],

                productType: 'T',
                productName: rowData['수강권명'] ? rowData['수강권명'].trim() : '',
                productComment: rowData['수강권명'] ? rowData['수강권명'].trim() : '',
                ticketType:
                    rowData['수강권종류'] === '그룹'
                        ? 'G'
                        : rowData['수강권종류'] === '개인'
                        ? 'P'
                        : rowData['수강권종류'] === '듀엣'
                        ? 'D'
                        : rowData['수강권종류'] === '회원권'
                        ? 'T'
                        : rowData['수강권종류']
                        ? 'P'
                        : '',
                periodType: 'M',
                periodCount: moment(rowData['수강권종료일']).diff(rowData['수강권시작일'], 'months'),
                lessonCountType: rowData['주당횟수'] ? 'W' : 'T',
                lessonCount: rowData['주당횟수']
                    ? rowData['주당횟수']
                    : typeof rowData['전체횟수'] !== 'string'
                    ? rowData['전체횟수']
                    : rowData['전체횟수'].trim(),
                lessonTime: 60,
                lessonPerLessonCount: 1,
                lessonMemberCount: 0,
                lessonCrossYn: false,
                lessonStaffId: null,
                resvAppYn: false,
                resvLimitType: rowData['주당횟수'] ? 'W' : 'U',
                resvLimitCount: rowData['주당횟수'] ? rowData['주당횟수'] : 7,
                resvDayDupYn: false,
                resvCancelType: 'U',
                resvCancelCount: 7,
                turnBillPrice: 0,
                recvPrice:
                    typeof rowData['결제금액'] !== 'string'
                        ? rowData['결제금액']
                        : parseInt(rowData['결제금액'].trim().replace(/\s/g, ""), 10),
                sellPrice:
                    typeof rowData['결제금액'] !== 'string'
                        ? rowData['결제금액']
                        : parseInt(rowData['결제금액'].trim().replace(/\s/g, ""), 10),
                vatYn: false,
                stockType: '-',
                stockTotalCount: null,
                stockManualYn: false,
                stockUseYn: true,

                contractType: 'N',
                totalProductCount: 0,
                totalOrgPrice:
                    typeof rowData['결제금액'] !== 'string'
                        ? rowData['결제금액']
                        : parseInt(rowData['결제금액'].trim().replace(/\s/g, ""), 10),
                totalBuyPrice:
                    typeof rowData['결제금액'] !== 'string'
                        ? rowData['결제금액']
                        : parseInt(rowData['결제금액'].trim().replace(/\s/g, ""), 10),
                regStaffId: null,
                mileageUsePrice: 0,
                etcDiscountPrice: 0,
                retunYn: false,
                centerProductVersion: 0,
                totalDebtPrice: 0,
                lockerNo: null,
                pw: null,
                lockerStatus: '-',
                rentMonth: null,
                rentStartedAt: null,
                rentEndedAt: null,
                // productBuyPrice: 0,
                // productOrgPrice: 0,

                productBuyPrice:
                    typeof rowData['결제금액'] !== 'string'
                        ? rowData['결제금액']
                        : parseInt(rowData['결제금액'].trim().replace(/\s/g, ""), 10),
                productOrgPrice:
                    typeof rowData['결제금액'] !== 'string'
                        ? rowData['결제금액']
                        : parseInt(rowData['결제금액'].trim().replace(/\s/g, ""), 10),
                products: [
                    {
                        centerProductId: '',
                        centerProductVersion: '',
                        expireEndDt: new Date(rowData['수강권종료일']),
                        expireStartDt: new Date(rowData['수강권시작일']),
                        lessStaffContractType: 'N',
                        lessonCount: rowData['잔여횟수'] ? rowData['잔여횟수'] : rowData['주당횟수'],
                        lessonCountType: rowData['주당횟수'] ? 'W' : 'T',
                        lessonResverStaffYn: false,
                        saleStaffContractType: 'N',
                        lessonStaffName : rowData['담당강사']

                    },
                ],
                bills: [
                    {
                        billPrice:
                            typeof rowData['결제금액'] !== 'string'
                                ? rowData['결제금액']
                                : parseInt(rowData['결제금액'].trim().replace(/\s/g, ""), 10),
                                billSeq: 0,
                        buyDate: rowData['결제일시'],
                        debtYn: false,
                        mileage: 0,
                        payType: 'E',
                    },
                ],
            };
            this.customerParam.push(customerInfo);
        },

        // 페이지 이동
        onClickRouter(path) {
            this.$router.push({
                path: `${path}/${this.centerId}`,
            });
        },
        async  checkVaildMigExcelData(sheet){
           
           for (const rowData of sheet) {
                const format = "YYYY-MM-DD";

              // console.log(rowData);
               let maxlength = 0;
               let isValid = true;
               let  excelData = rowData['이름'] || '';
               excelData = excelData.trim();
               maxlength = 24;

               if (excelData.length > maxlength || excelData.length <= 0) {
                   isValid = false;
                   rowData['이름'] = `[ERROR] 최대 입력 길이 초과( ${maxlength} 또는 필수값 누락) : ${excelData}`;
               }

               excelData = rowData['전화번호'] || '';
               excelData = excelData.trim();
               maxlength = 13;

               if (excelData.length > maxlength || excelData.length <= 0) {
                   isValid = false;
                   rowData['전화번호'] = `[ERROR] 최대 입력 길이 초과( ${maxlength} 또는 필수값 누락) : ${excelData}`;
               }


               excelData = rowData['수강권시작일'] || ''; 
               excelData = excelData.trim();
               maxlength = 0;
               if (!moment(excelData, format, true).isValid()) {
                   isValid = false;
                   rowData['수강권시작일'] = `[ERROR] 날짜 포맷 확인(${format}) : ${excelData}`;
               }

               excelData = rowData['수강권종료일'] || '';
               excelData = excelData.trim();
               maxlength = 0;
               if (!moment(excelData, format, true).isValid()) {
                   isValid = false;
                   rowData['수강권종료일'] = `[ERROR] 날짜 포맷 확인(${format} 또는 필수값 누락) : ${excelData}`;
               }

               excelData = rowData['수강권발급일'] || '';
               excelData = excelData.trim();
               maxlength = 0;
               if (!moment(excelData, format, true).isValid() && excelData.length > 0) {
                   isValid = false;
                   rowData['수강권발급일'] = `[ERROR] 날짜 포맷 확인(${format} 또는 필수값 누락) : ${excelData}`;
               }

               excelData = rowData['등록일'] || '';
               excelData = excelData.trim();
               maxlength = 0;
               if (!moment(excelData, format, true).isValid() && excelData.length > 0) {
                   isValid = false;
                   rowData['등록일'] = `[ERROR] 날짜 포맷 확인(${format} 또는 필수값 누락) : ${excelData}`;
               }

               excelData = rowData['결제일시'] || '';
               excelData = excelData.trim();
               maxlength = 0;
               if (!moment(excelData, format, true).isValid() && excelData.length > 0) {
                   isValid = false;
                   rowData['결제일시'] = `[ERROR] 날짜 포맷 확인(${format} 또는 필수값 누락) : ${excelData}`;
               }

               if(!isValid) this.migExcelErrors.push(rowData);


           }

           console.log('마그레이션 엑셀 파일 내에 데이터 오류건수' + '[' + this.migExcelErrors.length +']');
           if(this.migExcelErrors.length > 0){
               if (!confirm('마그레이션 엑셀 파일 내에 데이터 오류가 있습니다. 상세내역 다운로드를 진행하시겠습니까?'))  {
                   return;
               }

               this.exportToExcel();
           }
       },
       exportToExcel() {
           try {
               const data = this.migExcelErrors;
               const worksheet = XLSX.utils.json_to_sheet(data);
               const workbook = XLSX.utils.book_new();
               XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
               const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
               this.saveAsExcelFile(excelBuffer, "error_data");
           } catch (error) {
               this.errorMessage = "엑셀 파일 생성 중 오류가 발생했습니다.";
               console.error("엑셀 파일 생성 오류:", error);
           }
    }, saveAsExcelFile(buffer, fileName) {
       try {
           const data = new Blob([buffer], { type: "application/octet-stream" });
           const link = document.createElement("a");
           link.href = window.URL.createObjectURL(data);
           link.setAttribute("download", `${fileName}.xlsx`);
           document.body.appendChild(link);
           link.click();
           document.body.removeChild(link);
       } catch (error) {
           this.errorMessage = "파일 다운로드 중 오류가 발생했습니다.";
           console.error("파일 다운로드 오류:", error);
       }
    }

    },
};
</script>
<style lang="scss"></style>
